<div class="container px-md-0">
  <div class="row">
    <div class="col-md-7 team-content">
      <app-promo-banner style="margin-bottom: 16px"></app-promo-banner>
      <lib-ad-sponsor-banner
        *ngIf="teamService.currentTeam"
        [entityId]="teamService.currentTeam._id"
        [entityType]="entityType"
        [hideHeader]="true">
      </lib-ad-sponsor-banner>
      <div class="team-squad-subnav">
        <a class="mat-select-button" routerLink="/kader/spieler" routerLinkActive="selected">
          Spieler
        </a>
        <a class="mat-select-button" routerLink="/kader/trainer" routerLinkActive="selected">
          Trainer & Betreuer
        </a>
      </div>
      <router-outlet></router-outlet>
    </div>
    <div class="col-md-5 team-sidebar">
      <div class="row">
        <lib-ad class="col-12 mt-2 mt-md-0"></lib-ad>
      </div>
    </div>
  </div>
</div>
